import { get, getRawValue } from '../../../utils/get';
import { CONTEXT_PROPS } from '../../../types/ContextProps';
import { getKeys as _getKeys } from '../../../adapters/utils';
var IDs = {
  SITE_NAME: 'site.name',
  INDEX_SITE: 'site.index',
  INDEX_PAGE: 'page.index',
  NAME: 'category.name',
  DESCRIPTION: 'category.description',
  IMAGE: 'category.image',
  IMAGE_WIDTH: 'category.image.width',
  IMAGE_HEIGHT: 'category.image.height',
  CATEGORY_PAGE_URL: 'category.url',
  POST_AMOUNT: 'category.posts.amount',
  VIEW_AMOUNT: 'category.views.amount'
};
var userVisible = [IDs.NAME, IDs.POST_AMOUNT, IDs.VIEW_AMOUNT, IDs.DESCRIPTION, IDs.CATEGORY_PAGE_URL, IDs.IMAGE, IDs.SITE_NAME];
export default {
  IDs: IDs,
  getData: function getData(item) {
    var _ref;

    return _ref = {}, _ref[IDs.SITE_NAME] = get(item, "context." + CONTEXT_PROPS.SITE_NAME), _ref[IDs.INDEX_SITE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_SITE), _ref[IDs.INDEX_PAGE] = getRawValue(item, "context." + CONTEXT_PROPS.INDEX_PAGE), _ref[IDs.NAME] = get(item, 'category.title'), _ref[IDs.DESCRIPTION] = get(item, 'category.description'), _ref[IDs.IMAGE] = get(item, 'category.images.0.src'), _ref[IDs.IMAGE_WIDTH] = get(item, 'category.images.0.width'), _ref[IDs.IMAGE_HEIGHT] = get(item, 'category.images.0.height'), _ref[IDs.CATEGORY_PAGE_URL] = get(item, 'category.refersTo'), _ref[IDs.POST_AMOUNT] = get(item, 'category.totalPosts'), _ref[IDs.VIEW_AMOUNT] = get(item, 'category.totalViews'), _ref;
  },
  getLegacySeoBlob: function getLegacySeoBlob() {},
  getSlug: function getSlug() {
    return '';
  },
  updateItemDataWithSlug: function updateItemDataWithSlug(item) {
    return item;
  },
  getBiData: function getBiData() {},
  getKeys: function getKeys() {
    return _getKeys(IDs, userVisible);
  }
};